<template>
    <div>
        <div v-if="loading" class="loading"></div>
        <div v-if="errors" v-for="error in errors">
            <div class="div" v-if="Array.isArray(error)">
                <div class="alert alert-danger" role="alert" v-for="er in error">{{ er }}</div>
            </div>
            <div class="alert alert-danger" role="alert" v-else>{{ error }}</div>

        </div>

        <b-form @submit="onSubmit">
            <b-form-group
                    id="input-subject"
                    label="Тема"
                    label-for="subject"
                    description=""
            >
                <b-form-input
                        id="subject"
                        v-model="subj"
                        type="text"
                        placeholder="Тема"
                ></b-form-input>
            </b-form-group>

            <h4 class="mt-2 mb-2">Сообщение</h4>
            <ckeditor :editor="editor" v-model="msg" :config="editorConfig"></ckeditor>
            <!-- <div class="editor"></div> -->

            <div class="buttons mt-5">
                <b-button type="submit">Отправить</b-button>
            </div>
        </b-form>
    </div>
</template>

<script>

    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import UploadAdapter from './uploadAdapter';

    export default {
        name: "AdminMailingsMessage",
        props: ['message'],

        data() {
            return {
                editor: ClassicEditor,
                editorConfig: {
                    extraPlugins: [this.MyCustomUploadAdapterPlugin],
                    language: 'nl',
                },
                msg: '',
                subj: '',
                errors: [],
                loading: false
            }
        },

        methods: {
            MyCustomUploadAdapterPlugin (editor) {
                editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                    return new UploadAdapter( loader );
                };
            },

            checkForm:function(e) {
                e.preventDefault();
                this.errors = [];
                if(!this.msg) this.errors.push("Сообщение обязательно");
            },

            onSubmit(e){
                this.checkForm(e)
                e.preventDefault()
                let formData = new FormData();
                formData.append('msg', this.msg);
                formData.append('subj', this.subj);
                formData.append('emails', JSON.stringify(this.$route.query))

                if (this.errors.length === 0){
                    this.axios
                        .post(this.axios.defaults.baseURL + 'admin/send-email', formData)
                        .then(response => {
                            if (response.data.message === 'ok') {
                                this.$router.push({name: 'AdminMailings', params: {message: 'Сообщение успешно отправлено!'}})
                            }else {
                                this.errors = response.data.errors
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        })
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/app/admin/mailings/message.vue